// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-11-10T09:33:29Z                      #

// ##############################################################


/**
 * Vyjmenované hodnoty pro state.
 */
enum EnumState {
    INIT = 'INIT', 
    STORNO = 'STORNO', 
    SIGN_IN_PROGRESS = 'SIGN_IN_PROGRESS', 
    SIGNED = 'SIGNED', 
    APPROVED = 'APPROVED', 
    REJECTED = 'REJECTED', 
    ERROR = 'ERROR', 
    USER_SIGNING = 'USER_SIGNING', 
    ERROR_SEALING = 'ERROR_SEALING'
};
export default EnumState;

/**
 * Mapa enumu na objekt s podrobnostmi o enumu.
 */
const params = {
    [EnumState.INIT]: {caption: ''},
    [EnumState.STORNO]: {caption: ''},
    [EnumState.SIGN_IN_PROGRESS]: {caption: ''},
    [EnumState.SIGNED]: {caption: ''},
    [EnumState.APPROVED]: {caption: ''},
    [EnumState.REJECTED]: {caption: ''},
    [EnumState.ERROR]: {caption: ''},
    [EnumState.USER_SIGNING]: {caption: ''},
    [EnumState.ERROR_SEALING]: {caption: ''}
};

/**
 * Načtení popisku enumu.
 * @return popisek enumu
 */
export function getCaption(value) {
    return params[value].caption;
}
